



































import { computed, defineComponent } from '@vue/composition-api';
import { ButtonPalettes } from '@front-app/components/buttons/palettes';
import { ADD_ICON } from '@front-app/vendor/icon-definitions';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import CtaButton from '@front-app/components/buttons/CtaButton.vue';
import CountBadge from '../CountBadge.vue';

export default defineComponent({
	components: {
		CtaButton,
		FontAwesomeIcon,
		CountBadge,
	},
	props: {
		numNotes: {
			type: Number,
			required: true,
		},
		numUnreadNotes: {
			type: Number,
			required: true,
		},
	},
	setup(props) {
		const countPalette = computed(() => (props.numUnreadNotes > 0 ? ButtonPalettes.PRIMARY : ButtonPalettes.DEFAULT));
		return {
			ADD_ICON,
			countPalette,
		};
	},
});
